<template>
  <div class="total bgps flex fd">
    <theader />
    <div class="content f1 flex">
      <div class="left side flex fd">
        <longbluetitle :titlearr="['视频监控列表']" />
        <div class="f1 sidecon">
          <div class="icon flex">
            <div class="flex fd jc ac iconlist f1 bgps">
              <img src="../assets/image/video/视频.png" alt />
              <p style="font-size: 1.25vw; color: #d9e7ff">{{totalIpc}}</p>
              <p>在线摄像头</p>
            </div>
            <div class="flex fd jc ac iconlist f1 bgps">
              <img src="../assets/image/video/wifi.png" alt />
              <p style="font-size: 1.25vw; color: #D9E7FF">{{ tableData.length>0 ?'100%':0 }}</p>
              <p>摄像头在线率</p>
            </div>
            <div></div>
          </div>
          <t-input v-model="inputs" placeholder="请输入设备名称" />
          <div style="height: 36vw; overflow: auto;">
            <el-menu default-active="0" class="el-menu-vertical-demo" background-color="#031837" text-color="#fff"
              @open="handleOpen" @close="handleClose">
                  <el-menu-item-group v-if="tableData.length>0">
                    <el-menu-item  v-for="(v2, i2) in tableData[0].equipList" :key="v2.ysSerialNo" :index="i2"  >
                      <div class="xuan" @dblclick="handleDoubleClick(v2)">
                        <div>
                          <img src="../assets/image/video/链接@2x.png" alt style="width: 1.25rem;" />
                          <img src="../assets/image/video/icon／工程信息备份@2x.png" alt
                            style="margin:0 8px;width: 1.25rem;" />
                            <span  style="width: 80%;">{{ v2.ysChannelName }}</span>
                        </div>
                        <div class="iconbox" style="margin-left: 50px;"></div>
                      </div>
                    </el-menu-item>
                  </el-menu-item-group>
                <!-- </el-submenu> -->
            </el-menu>

          </div>
          <!-- <t-enhanced-table
            ref="table"
            row-key="total"
            :data="data"
            :columns="columns"
            :tree="{
              childrenKey: 'childrenList',
              treeNodeColumnIndex: 0,
              expandTreeNodeOnClick: true,
            }"
            @expanded-tree-nodes-change="onExpandedTreeNodesChange"
          ></t-enhanced-table>-->
        </div>
      </div>
      <div class="center f1 flex fd">
        <div class="flex" style="display: flex;justify-content: space-between">
          <longbluetitle :titlearr="['视频监控墙']" />

          <div class="flex pa ac"style="height: 1.56vw; top: 0.26vw; right: 1.3vw;">
            <div style="display: flex; height: 100%;width: 60.8vw;;justify-content: center;">
              <div  class="flex ac">
                <span v-if="liveUrlHdArr.length > nums">轮播间隔：</span>
                 <bluetabs  :tabList="tabLists" :t2value="sweir" @tabchange="tabIntervalChange" v-if="liveUrlHdArr.length > nums" />
              </div>
              <div  class="flex ac" style="padding-left: .64rem;">布局：
                <bluetabs style="padding-right: 1.7rem;"  :tabList="tabList" @tabchange="tabchange" :t2value="grids" />
              </div>

              <div class="flex ac" style="padding-right: 1.7rem;">
                清晰度设置：
                <bluetabs :tabList="tabListss" :t2value="qing" @tabchange="tabchange2"
                  style="background: #16385E;height: 1.875rem;" />
              </div>
              <!-- <span style="display: flex;align-items: center;" > -->
              <div class="flex" style="align-items: center;">
                <div class='is-auto' style=" padding-right: .64rem;">自动播放</div>
                <el-switch
                @change='isAutoChange'
                  v-model="isAuto " style="display: block"
                  inactive-color="#8CA9C5">
                </el-switch>
              </div>
            </div>

            <!-- 轮播间隔：
            <bluetabs :tabList="tabLists" />-->

            <button style="width: 5rem;
              height: 100%;
              background: #2390F4;
              border: 1px solid #2390F4 ;
              border-radius: .25rem;color: #fff;" @click="visible5 = true">清除</button>
          </div>
        </div>
        <div class="centermain f1 flex fd">

          <videodan @delobj='delVedio' :isShowAdd="false" :hdArr="hdArr" :qing="qing" :token="token" v-if="grids == 1" />
          <videosi  @delobj='delVedio' :isShowAdd="false" :hdArr="hdArr"  :qing="qing" :token="token" v-if="grids == 2" />
          <!-- <videoliu :hdArr="hdArr" :qing="qing" :token="token" v-if="grids==3"/> -->
          <div class="liugongge" v-if="grids == 3">
            <div class="top">
              <div class="left liuleftbox" v-if="hdArr.length >= 1">
                <vidobox  @delobj='delVedio' :id="'vido1'" :isShowAdd="false"  :url="qing == 1 ? hdArr[0].liveUrl : hdArr[0].liveUrlHd" :list="hdArr[0]"
                  :width="liuleftwidth" :height="liuleftheight" :kbottom="'0px'" :token="token"
  />
              </div>
              <div class="left liuleftbox" v-if="hdArr.length < 1 || hdArr.length == 0">
                <!-- <i class="el-icon-film"></i> -->
                <img src="../assets/image/暂无视频@2x.png" alt />
                <p>
                  点击
                  <span>视频监控列表</span>
                  加载视频流
                </p>
              </div>
              <div class="right">
                <div v-if="hdArr.length >= 2" class="liurightbox">
                  <vidobox @delobj='delVedio' :id="'vido2'" :isShowAdd="false" :url="qing == 1 ? hdArr[1].liveUrl : hdArr[1].liveUrlHd" :list="hdArr[1]"
                    :width="liurightwidth" :height="liurightheight" :kbottom="'0px'" :token="token" />
                </div>
                <div v-if="hdArr.length >= 3" class="liurightbox">
                  <vidobox  @delobj='delVedio' :id="'vido3'" :isShowAdd="false" :url="qing == 1 ? hdArr[2].liveUrl : hdArr[2].liveUrlHd" :list="hdArr[2]"
                    :width="liurightwidth" :height="liurightheight" :kbottom="'0px'" :token="token" />
                </div>
                <div v-if="hdArr.length < v || hdArr.length == 0" v-for="(v, i) in [2, 3]" :key="i" class="liurightbox">
                  <img src="../assets/image/暂无视频@2x.png" alt />
                  <p>
                    点击
                    <span>视频监控列表</span>
                    加载视频流
                  </p>
                </div>
              </div>
            </div>
            <div class="bottom">
              <div v-if="hdArr.length >= 4" class="liubotbox">
                <vidobox :id="'vido4'"  @delobj='delVedio' :isShowAdd="false" :url="qing == 1 ? hdArr[3].liveUrl : hdArr[3].liveUrlHd" :list="hdArr[3]"
                  :width="liubotwidth" :height="liubotheight" :kbottom="'0px'" :token="token" />
              </div>
              <div v-if="hdArr.length >= 5" class="liubotbox">
                <vidobox :id="'vido5'"  @delobj='delVedio' :isShowAdd="false" :url="qing == 1 ? hdArr[4].liveUrl : hdArr[4].liveUrlHd" :list="hdArr[4]"
                  :width="liubotwidth" :height="liubotheight" :kbottom="'0px'" :token="token" />
              </div>
              <div v-if="hdArr.length >= 6" class="liubotbox">
                <vidobox :id="'vido6'"  @delobj='delVedio' :isShowAdd="false" :url="qing == 1 ? hdArr[5].liveUrl : hdArr[5].liveUrlHd" :list="hdArr[5]"
                  :width="liubotwidth" :height="liubotheight" :kbottom="'0px'" :token="token" />
              </div>
              <div v-if="hdArr.length < v || hdArr.length == 0" v-for="(v, i) in [4, 5, 6]" :key="i" class="liubotbox">
                <img src="../assets/image/暂无视频@2x.png" alt />
                <p>
                  点击
                  <span>视频监控列表</span>
                  加载视频流
                </p>
              </div>
            </div>
          </div>

          <videoone  @delobj='delVedio' :isShowAdd="false" :hdArr="hdArr" :qing="qing" :token="token" v-if="grids == 4" />

          <div class="centerfoor flex jb">

            <div class="flex ac" style="margin-left: auto;">

              <el-pagination background @current-change="onChange" :current-page.sync="current"
                :page-sizes="[1, 4, 6, 9]" :page-size="nums" layout="total, prev, pager, next"
                :total="liveUrlHdArr.length"></el-pagination>
            </div>
          </div>
        </div>
      </div>

    </div>
    <tmenu />
    <!-- <el-dialog title="清除" :visible.sync="visible5">
      <p>清除会导致所有通道被清除，请确认是否执行删除？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible5 = false">取 消</el-button>
        <el-button type="primary" @click="delall()">确 定</el-button>
      </span>
    </el-dialog>-->
    <div class="zhe" v-show="visible5">
      <div class="box">
        <div class="head">
          <div>
            <img src="../assets/image/video/1.Base基础／3.Icon图标／反馈／info-circle-filled@2x (1).png" alt />
            清除提醒
          </div>
          <img src="../assets/image/video/1.Base基础／3.Icon图标／反馈／info-circle-filled备份@2x.png" alt
            @click="visible5 = false" />
        </div>
        <div class="body">
          <p>清除会导致所有通道被清除，请确认是否执行删除？</p>
          <div>
            <button @click="visible5 = false">取 消</button>
            <button @click="delall()" style="margin-left: .625rem;">确 定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible5: false,
      sweir: '1',
      isAuto:false,//自动播放
      token: "",
      totalIpc:0,
      shotlist: [
        {
          type: "未戴头盔识别",
          address: "1工区南侧-1号楼区域",
          time: "2024/01/19 16:35:52",
          icon: ""
        },
        {
          type: "未戴头盔识别",
          address: "1工区南侧-1号楼区域",
          time: "2024/01/19 16:35:52",
          icon: ""
        },
        {
          type: "未戴头盔识别",
          address: "1工区南侧-1号楼区域",
          time: "2024/01/19 16:35:52",
          icon: ""
        },
        {
          type: "未戴头盔识别",
          address: "1工区南侧-1号楼区域",
          time: "2024/01/19 16:35:52",
          icon: ""
        }
      ],
      current: 1,
      pageSize: 5,
      grids: 1,
      inputs: "",
      data: [
        {
          total: "勘测单位: 勘测-单位1",
          time: "竣工时间: 2023-04-26",
          childrenList: [
            { total: "勘测单位: 勘测-单位7", time: "竣工时间: 2023-04-26" },
            { total: "勘测单位: 勘测-单位8", time: "竣工时间: 2023-04-26" }
          ]
        },
        { total: "勘测单位: 勘测-单位2", time: "竣工时间: 2023-04-26" },
        { total: "勘测单位: 勘测-单位3", time: "竣工时间: 2023-04-26" },
        { total: "勘测单位: 勘测-单位4", time: "竣工时间: 2023-04-26" },
        { total: "勘测单位: 勘测-单位5", time: "竣工时间: 2023-04-26" },
        { total: "勘测单位: 勘测-单位6", time: "竣工时间: 2023-04-26" }
      ],
      columns: [
        { colKey: "total", title: "项目总造价: (单价/万元)" },
        { colKey: "time", title: "开工时间: 2019-12-12" }
      ],
      tabv: 0,
      tabList: [
        { label: "九宫格", value: 4, img: require("../assets/image/video/jgg.png") },
        { label: "六宫格", value: 3, img: require("../assets/image/video/wgg.png") },
        { label: "四宫格", value: 2, img: require("../assets/image/video/sgg.png") },
        { label: "单格", value: 1, img: require("../assets/image/video/dg.png") }
      ],
      tabsv: 0,
      tabLists: [
        { label: "无轮播", value: "1" },
        { label: "5分钟", value: "2" },
        { label: "10分钟", value: "3" }
      ],
      tabssv: 0,
      tabListss: [
        { label: "流畅", value: "1" },
        { label: "高清", value: "2" }
      ],
      liveUrlHdArr: [],
      UrlHdArr: [],
      hdArr: [],
      grids: 3,
      nums: 6,
      tableData: [],
      bookmarkList: [],
      qing: 1,
      liuleftwidth: 0,
      liuleftheight: 0,
      liurightwidth: 0,
      liurightheight: 0,
      liubotwidth: 0,
      liubotheight: 0,
      openedKeys: [] // 记录打开的菜单项
    };
  },
  mounted() {
    this.getshuList();
    this.getBox();

    // this.getbookmarkList()
  },
  created() {
    this.arrowIcon(0)
    this.handleOpen(0)
    this.isOpen(0)
  },
  methods: {
    arrowIcon(index) {
      console.log(index, 513);
      return this.isOpen(index)
        ? require("../assets/image/video/展开@2x.png")
        : require("../assets/image/video/折@2x.png");
    },
    isAutoChange(auto){
      this.isAuto = auto

      this.$store.commit('setAuto', this.isAuto)
    },
    tabIntervalChange(a) {
			this.sweir = a.value;
			if (a.value == 1) {
				this.current = 1;
				clearInterval(this.timer);
			}
			if (a.value == 2) {
				this.timer = setInterval(() => {
					this.current++;
					if (this.current >= this.liveUrlHdArr.length + 1) {
						this.current = 1;
					}
					this.getTabelData2();
				}, 300000); // 300000毫秒 = 5分钟
			}
			if (a.value == 3) {
				this.timer = setInterval(() => {
					this.current++;
					if (this.current > this.liveUrlHdArr.length) {
						this.current = 1;
					}
					this.getTabelData2();
				}, 600000); // 600000毫秒 = 10分钟
			}
		},
    delVedio(obj){
      const index =  this.hdArr.findIndex(item=>item.liveUrl==obj.liveUrl)
      this.hdArr.splice(index,1)
      this.liveUrlHdArr.splice(index,1)
    },
    isOpen(index) {
      return this.openedKeys.includes(index);
    },
    handleOpen(index) {
      if (!this.openedKeys.includes(index)) {
        this.openedKeys.push(index);
      }
    },
    handleClose(index) {
      this.openedKeys = this.openedKeys.filter(key => key !== index);
    },
    delall() {
      this.hdArr = [];
      this.liveUrlHdArr = [];
      this.visible5 = false;
    },
    getBox() {
      let box = document.getElementsByClassName("liuleftbox");
      this.liuleftwidth = box[0].clientWidth;
      this.liuleftheight = box[0].clientHeight;
      let box1 = document.getElementsByClassName("liurightbox");
      this.liurightwidth = box1[0].clientWidth;
      this.liurightheight = box1[0].clientHeight;
      let box2 = document.getElementsByClassName("liubotbox");
      this.liubotwidth = box2[0].clientWidth;
      this.liubotheight = box2[0].clientHeight;
      console.log(this.liuleftwidth, this.liuleftheight, 390);
      console.log(this.liurightwidth, this.liurightheight, 390);
      console.log(this.liubotwidth, this.liubotheight, 390);
    },
    tabchange1(a) {
      this.sweir = a.value;
      if (a.value == 1) {
        this.current = 1;
        clearInterval(this.timer);
      }
      if (a.value == 2) {
        this.timer = setInterval(() => {
          this.current++;
          if (this.current >= this.liveUrlHdArr.length + 1) {
            this.current = 1;
          }
          this.getTabelData2();
        }, 300000); // 300000毫秒 = 5分钟
      }
      if (a.value == 3) {
        this.timer = setInterval(() => {
          this.current++;
          if (this.current > this.liveUrlHdArr.length) {
            this.current = 1;
          }
          this.getTabelData2();
        }, 600000); // 300000毫秒 = 5分钟
      }
    },
    tabchange2(a) {
      this.qing = a.value;
    },
    handleDoubleClick(arr) {
      if(arr.equipList){

        this.liveUrlHdArr = []
        arr.equipList.forEach((v1, i) => {
          this.UrlHdArr.push(v1);
          this.liveUrlHdArr.push((v1))
        });
      }else{
        if( this.liveUrlHdArr.filter(item=>item.equipmentId===arr.equipmentId).length!==0) return
          this.UrlHdArr.push(arr);
          this.liveUrlHdArr.push((arr))
      }

      this.getTabelData2();
    },
    async getshuList() {
      let res = await this.$https.get(this.$url.video.cameraList, "");
      this.tableData = res.data;
      if(res.data && res.data.length > 0){
        this.token = res.data[0]?.accessToken ||'at.8ssf2luz0ptdxnlfbr8byhih5xw9iqkz-8hgefz6b46-1m5yk4k-au9jxyhjm';
        this.totalIpc = res.data[0]?.equipList?.length || 0
      }

    },

    async getTabelData2() {
      this.hdArr = this.liveUrlHdArr.slice(
        (this.current - 1) * this.nums,
        this.nums * this.current
      );
    },
    onChange(pageInfo) {
      this.current = pageInfo;

      this.getTabelData2();
    },
    tabchange(e) {
      if (e.label == "layout") {
        this.grids = e.value;
      }
      this.current = 1;

      if (this.grids == 1) {
        this.nums = 1;
      }
      if (this.grids == 2) {
        this.nums = 4;
      }
      if (this.grids == 3) {
        this.nums = 6;
      }
      if (this.grids == 4) {
        this.nums = 9;
      }
      this.getTabelData2();
    },
    onExpandedTreeNodesChange(e) { }
  },
  beforeDestroy() {
    this.$store.commit("setAuto", false)
    clearInterval(this.timer);
  }
};
</script>

<style lang="scss" scoped>
.total {
  .content {
    .center {
      .centermain {
        .grid-item {
          width: 100%;
          height: calc(100% - 2.08vw - 2rem);
          background: #000;

          >div {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            i {
              font-size: 50px;
            }

            p {
              font-size: 1rem;
            }
          }
        }

        .sigongge {
          width: 100%;
          height: calc(100% - 2.08vw - 2rem);
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          align-items: center;

          >div {
            width: 49%;
            height: 48%;
            background: #000;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            i {
              font-size: 50px;
            }

            p {
              font-size: 16px;
            }
          }
        }

        .liugongge {
          width: 100%;
          height: calc(100% - 2.08vw - 2rem);

          .top {
            width: 100%;
            height: 65%;
            display: flex;

            >.left {
              width: 67%;
              height: 98%;
              background: #16385e;
              border-radius: 0.5rem;
              margin-left: 1%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              img {
                width: 15%;
                margin-bottom: 3%;
              }

              p {
                font-size: 1rem;
                color: #5d7c9e;

                span {
                  color: #ffffffa0;
                }
              }
            }

            >.right {
              width: 34%;
              height: 100%;
              margin-left: 1%;

              >div {
                width: 98%;
                height: 48%;
                background: #16385e;
                border-radius: 0.5rem;
                margin-bottom: 2%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                img {
                  width: 20%;
                  margin-bottom: 3%;
                }

                p {
                  font-size: 1rem;
                  color: #5d7c9e;

                  span {
                    color: #ffffffa0;
                  }
                }
              }
            }
          }

          .bottom {
            width: 100%;
            height: 33%;
            display: flex;

            >div {
              width: 32%;
              height: 100%;
              margin-left: 1%;
              background: #16385e;
              border-radius: 0.5rem;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              img {
                width: 20%;
                margin-bottom: 2%;
              }

              p {
                font-size: 1rem;
                color: #5d7c9e;

                span {
                  color: #ffffffa0;
                }
              }
            }
          }
        }

        .jiugongge {
          width: 100%;
          height: calc(100% - 2.08vw - 2rem);
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          align-items: center;

          >div {
            width: 32%;
            height: 32%;
            background: #000;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            i {
              font-size: 40px;
            }

            p {
              font-size: 14px;
            }
          }
        }

        .centerfoor {
          ::v-deep .t-pagination__total {
            color: white;
            margin-right: 1.04vw;
          }

          ::v-deep .t-pagination__number.t-is-current {
            background: #2390f4 !important;
            border: 0.05vw solid #2390f4 !important;
          }

          ::v-deep .t-pagination__number {
            background: #16385e;
            border: 0.05vw solid #16385e;
            color: white;
          }

          ::v-deep .t-input.t-is-readonly {
            background-color: #16385e;
            color: white;
          }

          ::v-deep .t-input__inner {
            color: white;
          }

          width: 100%;
          height: 2.08vw;
          margin-top: 0.42vw;
        }

        .grid {
          .grid-item {
            border-radius: 0.42vw;
            background: #16385e;
          }

          display: grid;
          gap: 0.52vw;
        }

        padding: 0.83vw 0.83vw 0.42vw 0.83vw;
      }

      box-shadow: inset 0px 0px 1.25vw 0px rgba(72, 125, 163, 0.5);
      border-radius: 0.42vw;
      border: 0.05vw solid rgba(131, 166, 199, 0.3);
      backdrop-filter: blur(0.73vw);
      background: rgba(0, 25, 49, 0.5);
    }

    .side {
      .sidecon {
        .shotlist {
          .shotsingle {
            img {
              width: 4.17vw;
              height: 5.21vw;
            }

            height: 6.67vw;
            padding: 0.73vw;
            background: #16385e;
            border-radius: 0.42vw;
            gap: 0.63vw;
          }

          gap: 0.83vw;
        }

        .icon {
          .iconlist {
            img {
             // width: 3.33vw;
              height: 2.6vw;
            }

            background: url("../assets/image/equipment/数字／匡备份.png") no-repeat;
          }

          margin-bottom: 0.73vw;
          width: 100%;
          height: 6.25vw;
          gap: 0.73vw;
        }

        padding: 0 0.83vw;
      }

      width: 16.51vw;
      background: rgba(0, 25, 49, 0.5);
      box-shadow: inset 0px 0px 1.25vw 0px rgba(72, 125, 163, 0.5);
      border-radius: 0.42vw;
      border: 0.05vw solid rgba(131, 166, 199, 0.3);
      backdrop-filter: blur(0.73vw);
    }

    padding-left: 10.89vw;
    padding-right: 1.04vw;
    margin-top: 1.04vw;
    gap: 1.04vw;
  }

  background: url("../assets/image/bgstaff.png") no-repeat;
}

::v-deep .t-input {
  background-color: #16385e;
  border: 0.05vw solid rgba(131, 166, 199, 0.3);
  border-radius: 0.21vw;
  backdrop-filter: blur(0.26vw);
}

::v-deep input::placeholder {
  color: #8a98a5 !important;
}

::v-deep .el-pagination .el-select .el-input .el-input__inner {
  background: #16385e !important;
  color: #fff;
  border: 0px;
}

::v-deep .el-pager li {
  background: #16385e !important;
  color: #fff !important;
}

::v-deep .el-pager .active {
  background: #2390f4 !important;
  color: #fff;
}

::v-deep .btn-prev {
  background: #021732 !important;
}

::v-deep .btn-next {
  background: #021732 !important;
}

::v-deep .el-pagination__total {
  color: #fff;
}

::v-deep .el-menu-item.is-active {
  background: #094588 !important;
  color: #fff;
}

::v-deep .el-menu-item:hover {
  background: #123256 !important;
}

::v-deep .el-submenu__title:hover {
  background: #123256 !important;
}

.zhe {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 25, 49, 0.9);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;

  .box {
    width: 30rem;
    height: 15.625rem;
    background: rgba(26, 50, 83, 0.9);
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.5),
      0px 2px 36px 0px rgba(0, 0, 0, 0.5), 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(12px);

    .head {
      width: 30rem;
      height: 3rem;
      background: #1e3e62;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.625rem;

      div {
        height: 100%;
        display: flex;
        align-items: center;

        img {
          width: 1.25rem;
          height: 1.25rem;
          margin-right: 0.3125rem;
        }
      }

      >img {
        width: 1.5625rem;
        height: 1.5625rem;
      }
    }

    .body {
      width: 30rem;
      height: 12.625rem;
      padding: 1.25rem;

      p {
        width: 27.5rem;
        height: 4.125rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.875rem;
        color: rgba(255, 255, 255, 0.9);
        line-height: 1.375rem;
        text-align: left;
        font-style: normal;
      }

      div {
        width: 27.5rem;
        height: 5.625rem;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;

        button {
          width: 3.75rem;
          height: 2rem;
          background: #23476f;
          color: rgba(255, 255, 255, 0.55);
          border-radius: 0.25rem;
          border: 0px;
          font-size: 0.875rem;
        }

        button:hover {
          background: #1074db;
          color: #fff;
        }
      }
    }
  }
}

::v-deep .el-icon-arrow-down:before {
  display: none;
}
::v-deep .el-menu{
  border:0px
}
// body</style>
